import { JSX } from 'react';
import { FieldValues } from 'react-hook-form';
import { NumericField, NumericFieldProps } from './form-fields/numeric';
import { ExchangeField, ExchangeFieldProps } from './form-fields/exchange';
import {
  AutocompleteField,
  AutocompleteFieldProps
} from './form-fields/autocomplete';
import { SymbolField, SymbolFieldProps } from './form-fields/symbol/symbol';
import { CheckboxField, CheckboxFieldProps } from './form-fields/checkbox';
import { SelectField, SelectFieldProps } from './form-fields/select';
import { TextField, TextFieldProps } from './form-fields/text';
import { FieldWrapper } from '../layout/field-wrapper';
import { DateField, DateFieldProps } from './form-fields/date';

export type FormFieldProps<T extends FieldValues> =
  | ExchangeFieldProps<T>
  | NumericFieldProps<T>
  | AutocompleteFieldProps<T>
  | SymbolFieldProps<T>
  | CheckboxFieldProps<T>
  | SelectFieldProps<T>
  | TextFieldProps<T>
  | DateFieldProps<T>;

export function FormField<T extends FieldValues>(
  props: FormFieldProps<T>
): JSX.Element {
  const content = (() => {
    switch (props.type) {
      case 'exchange':
        return <ExchangeField {...props} />;
      case 'numeric':
        return <NumericField {...props} />;
      case 'autocomplete':
        return <AutocompleteField {...props} />;
      case 'symbol':
        return <SymbolField {...props} />;
      case 'checkbox':
        return <CheckboxField {...props} />;
      case 'select':
        return <SelectField {...props} />;
      case 'text':
        return <TextField {...props} />;
      case 'date':
        return <DateField {...props} />;
      default:
        return <div>Unsupported field type</div>;
    }
  })();

  if (props.noWrapper) {
    return <>{content}</>;
  }

  return <FieldWrapper {...props.wrapperProps}>{content}</FieldWrapper>;
}
